/*global math Element_Matrix Element_Algebra*/ //ESLINT
import { ElementEleda } from "../../elements/ElementEleda.mjs";
import { symbolicEqual } from "./Utils-Algebra";
import { isConvertibleIntoLatex } from "../rendering/Utils-Latex-Rendering";
import { Element_Fraction } from "../../elements/Element_Math.mjs";
/**
 * Management of logic_compare Blockly bloc.
 * @param {*} operator
 * @param {*} arg1
 * @param {*} arg2
 */
export function compare(operator, arg1, arg2) {
  try {
    console.log(
      "compare ",
      operator,
      arg1,
      math.typeOf(arg1),
      arg2,
      math.typeOf(arg2)
    );
    let arg1Converted = convertArgumentBeforeCompare(arg1);
    let arg2Converted = convertArgumentBeforeCompare(arg2);
    switch (operator) {
      case "==":
        return equal(arg1Converted, arg2Converted);
      case "!=":
        return !equal(arg1Converted, arg2Converted);
      case "<":
        return math.smaller(arg1Converted, arg2Converted);
      case "<=":
        return math.smallerEq(arg1Converted, arg2Converted);
      case ">":
        return math.larger(arg1Converted, arg2Converted);
      case ">=":
        return math.largerEq(arg1Converted, arg2Converted);
    }
  } catch (e) {
    console.log("Utils-Numeric compare", e);
    return false;
  }
}
/**
 * Test if elements or elements' list are equal
 * @param {*} object
 * @param {*} secondObject
 * @returns
 */
function equal(object1, object2) {
  console.log("test equal btw ", object1, object2);
  try {
    //If math object are the same
    if (
      (["number", "Fraction", "BigNumber", "boolean", "Complex"].includes(
        math.typeOf(object1)
      ) ||
        object1 instanceof Element_Fraction) &&
      (["number", "Fraction", "BigNumber", "boolean", "Complex"].includes(
        math.typeOf(object2)
      ) ||
        object2 instanceof Element_Fraction) &&
      math.equal(object1, object2)
    ) {
      console.log("equal normal", object1, object2);
      return true;
    } else if (
      ["Array", "Matrix"].includes(math.typeOf(object1)) &&
      ["Array", "Matrix"].includes(math.typeOf(object2)) &&
      math.deepEqual(object1, object2)
    ) {
      console.log("equal List", object1, object2);
      //deepEqual (mathjs function) compares element one to one
      return true;
    } else if (
      [
        "FunctionNode",
        "SymbolNode",
        "ConstantNode",
        "OperatorNode",
        "ParenthesisNode",
      ].includes(math.typeOf(object1)) &&
      [
        "FunctionNode",
        "SymbolNode",
        "ConstantNode",
        "OperatorNode",
        "ParenthesisNode",
      ].includes(math.typeOf(object2)) &&
      symbolicEqual(object1, object2)
    ) {
      console.log("equal Expression", object1, object2);
      return true;
    } else if (
      object1 instanceof ElementEleda &&
      object2 instanceof ElementEleda
    ) {
      console.log("equal ElementEleda object", object1, object2);
      return object1.isEqualTo(object2);
    } else if (object1 === object2) {
      console.log("equal unknow object", object1, object2);
      return true;
    } else {
      //could be mathjs Unit
      console.log(
        "equal not same type try to compare anyway : it could trigger the exception",
        object1,
        object2
      );
      return math.equal(object1, object2);
    }
  } catch (e) {
    //compare object
    console.log("Catch equal : two objects compared have not the same type");
    return false;
  }
}

/**
 * Management of math_single Blockly bloc commands. Inspire from blockly math_single method
 * @param {*} operator
 * @param {*} arg
 * @returns
 */
export function single(operator, arg) {
  try {
    let argconverted = convertArgumentBeforeArithmetic(arg);
    switch (operator) {
      case "ABS":
        return math.abs(argconverted);
      case "ROOT":
        return math.sqrt(argconverted);
      case "LN":
        return math.log(argconverted);
      case "EXP":
        return math.exp(argconverted);
      case "POW10":
        return math.pow(10, argconverted);
      case "ROUND":
        return math.round(argconverted);
      case "ROUNDUP":
        return math.ceil(argconverted);
      case "ROUNDDOWN":
        return math.floor(argconverted);
      case "SIN":
        return math.sin(math.unit(argconverted, "deg"));
      case "COS":
        return math.cos(math.unit(argconverted, "deg"));
      case "TAN":
        return math.tan(math.unit(argconverted, "deg"));
      case "LOG10":
        return math.log10(argconverted);
      case "ASIN":
        return math.unit(math.asin(argconverted), "deg");
      case "ACOS":
        return math.unit(math.acos(argconverted), "deg");
      case "ATAN":
        return math.unit(math.atan(argconverted), "deg");
      default:
        throw Error("Unknown math operator: " + operator);
    }
  } catch (e) {
    console.log(e, operator, arg);

    return null;
  }
}

/**
 * Internal arithmetic operation
 * @param {*} operator
 * @param {*} arg1
 * @param {*} arg2
 * @returns
 */
export function arithmetic(operator, arg1, arg2) {
  try {
    if (arg1 === undefined || arg1 === null) {
      return undefined;
    }
    if (arg2 === undefined || arg2 === null) {
      return undefined;
    }
    let arg1converted = arg1;
    let arg2converted = arg2;
    //Because fractions can not be mix for instance with bignumber : math.add(math.fraction(1/2),math.bignumber(2))
    //Gives mathjs error : "Cannot implicitly convert a Fraction to BigNumber or vice versa.
    //Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction."
    // => In case arg1 is not Fraction and arg2 is fraction or the opposite convert all in fractions

    //console.log("arithmetic", operator, arg1, arg2);
    if (
      (arg1 instanceof math.Fraction && !arg2 instanceof math.Fraction) ||
      (!arg1 instanceof math.Fraction && arg2 instanceof math.Fraction)
    ) {
      console.log("Arithmetic Mix of Fraction and other types");
      arg1converted = math.fraction(arg1converted);
      arg2converted = math.fraction(arg2converted);
    }

    arg1converted = convertArgumentBeforeArithmetic(arg1converted);
    arg2converted = convertArgumentBeforeArithmetic(arg2converted);
    /*console.log(
      "arithmetic after conversion",
      operator,
      arg1converted,
      arg2converted
    );
*/
    switch (operator) {
      case "ADD":
        return math.add(arg1converted, arg2converted);
      case "MINUS":
        return math.subtract(arg1converted, arg2converted);
      case "MULTIPLY":
        return math.multiply(arg1converted, arg2converted);
      case "DIVIDE":
        return math.divide(arg1converted, arg2converted);
      case "POWER":
        return math.pow(arg1converted, arg2converted);
    }
  } catch (e) {
    console.log(e, operator, arg1, arg2);
    return undefined;
  }
}
/**
 * Convert argument mainly in bignumber if they are not, to prevent round errors.
 * @param {*} numeric
 * @returns
 */
function convertArgumentBeforeArithmetic(numeric) {
  console.log("convertArgumentBeforeArithmetic typeOf:", math.typeOf(numeric));
  switch (true) {
    case ["number", "boolean", "Complex"].includes(math.typeOf(numeric)):
      console.log(
        "convertArgumentBeforeArithmetic NOT Fraction or BigNumber:",
        numeric
      );
      return math.bignumber(numeric); //return a bignumber to prevent round error with arithmetic operator
    case numeric instanceof Number: //in case it has been converted thanks to a style
      return math.bignumber(numeric.valueOf());
    case ["Fraction", "BigNumber", "Unit", "Matrix", "Array"].includes(
      math.typeOf(numeric)
    ) || numeric instanceof Element_Fraction:
      /* console.log(
        "convertArgumentBeforeArithmetic Fraction or BigNumber:",
        numeric
      );*/
      return numeric; //return as it is
    case ["string"].includes(math.typeOf(numeric)) || numeric instanceof String:
      return parseFloat(numeric); //parsefloat convert a string into number. If impossible return NaN
    // other cases could be implemented to improve the function
    case ["Element_Algebra_Polynom"].includes(math.typeOf(numeric)):
      console.log(
        "Element_Algebra_Polynom convertArgumentBeforeArithmetic",
        numeric.toString()
      );
      return numeric;
    case numeric instanceof Element_Matrix:
      return numeric.toArray();
    //   case ["Object"].includes(math.typeOf(numeric)):
    //  console.log("convertArgumentBeforeArithmetic Object :", numeric);
    //    return parseFloat(numeric);
    default:
      return numeric;
  }
}

/**
 * Convert argument mainly before compare, slightly ≠ thant convertArgumentBeforeArithmetic.
 * Differences = you can add bignumber and fraction but not compare them (implicit error)
 * @param {*} numeric
 * @returns
 */
function convertArgumentBeforeCompare(object) {
  // console.log("convertArgumentBeforeArithmetic typeOf:", math.typeOf(numeric));
  switch (true) {
    case ["number", "Fraction", "BigNumber", "boolean", "Complex"].includes(
      math.typeOf(object)
    ) || object instanceof Element_Fraction:
      return math.number(object); //return a bignumber to prevent round error with arithmetic operator
    case object instanceof Number: //in case it has been converted thanks to a style
      return math.number(object.valueOf());
    case ["string"].includes(math.typeOf(object)) || object instanceof String:
      if (!isNaN(parseFloat(object))) {
        return math.number(parseFloat(object)); // if the string is a float return the float
      } else {
        return object;
      }
    default:
      return object;
  }
}

/**
 * Return an Int or float random number in a range
 * @param  {Number} lower bound
 * @param  {Number} upper bound
 * @param  {boolean} true is we want a Integer, false otherwise
 * @return {Number} the random number
 */

export function getRandomNum(min, max, isInt) {
  if (isInt) {
    return math.randomInt(math.number(min), math.number(max) + 1);
  } else {
    return math.random(math.number(min), math.number(max));
  }
}

/**
 * Use of specific method to prevent JS decimal part bug (round)
 * Ref : https://github.com/infusion/Fraction.js#get-the-exact-fractional-part-of-a-number
 * @param {*} n
 * @returns Number
 */
export function getDecimalPart(n) {
  /*
  var f = new math.Fraction("" + n); //cast intoString otherwise doesn't work
  return roundTo14Digits("" + f.mod(1).abs());
  */
  var dec = math.abs(
    math.subtract(math.bignumber(n), math.bignumber(math.floor(n)))
  );
  return dec;
}
/**
 * Reduce a fraction in its irreducible form
 * @param {*} math.Fraction
 * @returns math.Fraction
 */
export function reduceFraction(frac) {
  console.log("reduceFraction", frac);
  var s = frac.s; //sign
  var n = frac.n;
  var d = frac.d;
  var gcd = math.gcd(n, d);
  return new Element_Fraction(
    math.multiply(
      s,
      math.number(math.divide(math.bignumber(n), math.bignumber(gcd)))
    ),
    math.number(math.divide(math.bignumber(d), math.bignumber(gcd)))
  );
}

/**
 * Inspired from Ref : https://stackoverflow.com/questions/18082/validate-decimal-numbers-in-javascript-isnumeric/174921#174921
 * @param {} n
 * @returns
 */
/*
export function roundTo14Digits(n) {
  if (isNumeric(n)) {
    // MATHJS workaround precision JS issue : Limit precision to 14 digits instead of 16 to prevent JS error precision e.g. 0.1 +  0.2 => 0.30000000000000004
    //Ref : https://mathjs.org/docs/datatypes/numbers.html#roundoff-errors

    return Number(
      //to cast into standard number
      math.format(
        //math.format return a string
        n.valueOf(), //get valueOf() to get only value in case of Number JS Object otherwise simple number and no effect
        {
          notation: "fixed",
          precision: 14,
        }
      )
    );

    // return n;
  } else {
    return n;
  }
}
*/
export function createNumberArrayFromLength(length) {
  var numberArray = [];
  for (let i = 0; i < length; i++) {
    numberArray.push(i);
  }
  return numberArray;
}

/* Old fashion : work on string 
export function getDecimalPart(n) {
  //Impossible to get Decimal part in JS without getting 0.002999999993 instead of 0.3
  //Only solution is to work with String burk
  //make sure we work with point to seperate decimal part
  const parts = n
    .toLocaleString("en-US", {
      maximumSignificantDigits: 18,
    })
    .split(".");
  return parts.length > 1 ? Number("0." + parts[1]) : 0;
}
*/

/**
 * Test whether object is a standard JS numeric (not a Number prototype, not a MathJS object...)
 * Updated for Math.js v14 compatibility
 * @param {*} n - Value to test
 * @returns {boolean} Whether the value is a standard numeric
 */
export function isNumeric(n) {
  try {
    // Gérer les différents types de Math.js et JS
    if (n === null || n === undefined) return false;

    // Vérification pour les types primitifs
    if (typeof n === "number") {
      return !isNaN(n) && isFinite(n);
    }

    // Gérer les objets Math.js
    if (n && typeof n === "object") {
      // Ignorer les objets MathJS spéciaux
      if (n.isNode || n.isUnit || n.isComplex) return false;

      // Gérer BigNumber et Fraction
      if (n.valueOf) {
        const value = n.valueOf();
        return typeof value === "number" && !isNaN(value) && isFinite(value);
      }
    }

    //Si l'objet est vide ou composé d'un mélange de " " ou de " " (espace insécable uft /00A0:" ") ou si elle est composée exactement de deux zéros consécutifs ou plus
    //En effet en JS Number() ou math.number("00", "000", "" ou " ") renvoie 0.
    if (
      typeof n === "string" &&
      (/^[\s\u00A0]*$/.test(n) || /^0{2,}$/.test(n))
    ) {
      return false;
    }

    // Essayer de convertir en nombre
    const converted = math.number(n); //Math.number considère les "00" "000" ou les espaces "" comme 0 donc, on les a excluent plus haut
    return !isNaN(converted) && isFinite(converted);
  } catch (error) {
    // En cas d'erreur de conversion (comme avec BigInt)
    return false;
  }
}

/**
 * Flatten recursively an array. If item is an Array flatten only if math or numeric object return true
 * @param {*} items
 * @returns
 */
export function flatten(items) {
  const flat = [];
  items.forEach((item) => {
    if (
      Array.isArray(item) &&
      !item.every((object) => {
        return (
          isNumeric(object) ||
          object instanceof Number ||
          object instanceof math.BigNumber ||
          isConvertibleIntoLatex(object) ||
          typeof object == "boolean" ||
          object instanceof Element_Algebra
        );
      })
    ) {
      flat.push(...flatten(item));
    } else {
      flat.push(item);
    }
  });
  return flat;
}

export function splitNumberIntoDigits(number) {
  return math.number(number).toString().split("");
}
/**
 * MathJS mimic with conversion to bignumber before (and prevent null and undeifined element in sum)
 * @param {*} list
 */

export function sum(list) {
  return math.sum(
    list
      .filter((item) => item != null || item != undefined)
      .map((item) => math.bignumber(item))
  );
}

/**
 * MathJS mimic with conversion to bignumber before (and prevent null and undeifined element in sum)
 * @param {*} list
 */

export function mean(list) {
  return math.mean(
    list
      .filter((item) => item != null || item != undefined)
      .map((item) => math.bignumber(item))
  );
}

/**
 * MathJS mimic with conversion to bignumber before (and prevent null and undeifined element in sum)
 * @param {*} list
 */

export function median(list) {
  return math.median(
    list
      .filter((item) => item != null || item != undefined)
      .map((item) => math.bignumber(item))
  );
}

/**
 * MathJS mimic with conversion to bignumber before (and prevent null and undeifined element in sum)
 * @param {*} list
 */

export function mode(list) {
  return math.mode(
    list
      .filter((item) => item != null || item != undefined)
      .map((item) => math.bignumber(item))
  );
}

/**
 * MathJS mimic with conversion to bignumber before (and prevent null and undeifined element in sum)
 * @param {*} list
 */

export function std(list) {
  return math.std(
    list
      .filter((item) => item != null || item != undefined)
      .map((item) => math.bignumber(item)),
    "uncorrected"
  );
}
